import { useFrame, useThree } from "@react-three/fiber";
import LightRay from "./light-ray";
import { useEffect, useRef, useState } from "react";
import * as THREE from "three";
import engAvatr from "../../../../asset/FA1.png";
import TexturedPlane from "./textured-plane";
import Money from "./money";
import { useSelector } from "react-redux";
import { getCommunityDetails } from "../../../../feature/community-slice/community-slice";
import { getSurfacePosition } from "../../../../utils/planet-surface";
import { cashConfig, cloudConfig, profileConfig, ufoConfig } from "./planet-config";
import { getImageDetails } from "../../../../feature/image-slice";
import OrbMap from "../../../../shared/components/orb-map";
import { getAuthDetails } from "../../../../feature/auth-slice";
import { getCookie } from "../../../../utils/cookie";

type Props = {
  engage: boolean;
  mode?: "engage" | "heal";
  onEngaged: () => void;
  planetDetails: any;
  clickLocation?:any
  showMap?:any
};

const PlanetManage = ({ engage, onEngaged, mode , planetDetails ,clickLocation,showMap}: Props) => {
  const [adminEngage, setAdminEngage] = useState(false);
  const [instaHeal, setInstaHeal] = useState<boolean>(false);
  const [light, setLight] = useState(false);
  const authToken = getCookie("auth_token")
  const communityDetail = useSelector(getCommunityDetails);
  const imageDetail = useSelector(getImageDetails);
  const authDetail = useSelector(getAuthDetails);
  const { viewport } = useThree();
  const lightRef = useRef<any>(null);
  const cloudRef = useRef<any>(null);
  const cycleRef = useRef<any>(null);
  const anotherCycleRef = useRef<any>(null);
  const anotherCloudRef = useRef<any>(null);
  const moneyRef = useRef<any>(null);
  const money2Ref = useRef<any>(null);
  const money3Ref = useRef<any>(null);
  const cashRef = useRef<any>(null);
  const cash2Ref = useRef<any>(null);

  const surfaceRef = useRef<any>(null);
  const avatarRef = useRef<any>(null);
  const ufoRef = useRef<any>(null);
  const profileRef = useRef<any>(null);
  
  const landed = useRef<any>(null);
  const faded = useRef<any>(null);
  const isIdle = useRef<any>(null);
  const isLightOn = useRef<any>(null);

  const viewScale = viewport.width / 7 > 1 ? 1 : viewport.width / 7;
  const viewScale5x = viewport.width / 5 > 1 ? 1 : viewport.width / 5;


  const planetStructure = getSurfacePosition({
    land_type:planetDetails?.images?.[1]?.id ||8,
    surface_type: planetDetails?.images?.[2]?.id ||11,
    size: communityDetail.doc ? "sm" : "lg",
    imageDetail:imageDetail
  });

  const viewDiff = 1 - viewScale;

  const onActive = () => {
    setAdminEngage(true);
  };

  const onStopped = () => {
    if (mode === "heal") {
      setInstaHeal(true);
    } else {
      if (mode === "engage") setLight(true);
    }
  };

  const onLanded = () => {
    setLight(false);
  };




  useFrame((state, delta) => {

    //###################
    // light animation
    //###################

    if (lightRef.current && mode === "engage") {
  

      lightRef.current.target.position.set(-0.1, 0, 0);

      if (light) {
        //light slowly fades in

        lightRef.current.children[0].material.uniforms.opacity.value =
          THREE.MathUtils.lerp(
            lightRef.current.children[0].material.uniforms.opacity.value,
            1,
            0.05
          );
        lightRef.current.needsUpdate = true;
      } else {
        //light slowly fades out

        lightRef.current.children[0].material.uniforms.opacity.value =
          THREE.MathUtils.lerp(
            lightRef.current.children[0].material.uniforms.opacity.value,
            0,
            0.05
          );
        lightRef.current.needsUpdate = true;
      }
      if (
        Math.abs(
          lightRef.current.children[0].material.uniforms.opacity.value - 1
        ) < 0.01
      ) {
        //light is fully visible
        if (!isLightOn.current) {
          onActive();
          isLightOn.current = true;
        }
      }
    }

    //###################
    // clouds animation
    //###################

    if (cloudRef.current) {
      cloudRef.current.position.x =
        1.3 + Math.sin(state.clock.elapsedTime * 0.5) * 0.5;
    }

    if (anotherCloudRef.current) {
      anotherCloudRef.current.position.x =
      -1 + Math.sin(state.clock.elapsedTime * 0.5) * 0.5;
    }

    //##################
    //cycle animition
    //##################

    if (cycleRef.current) {
      const posX = cycleRef.current.position.x;
      cycleRef.current.position.x =
        Math.abs(0.16 - posX) < 0.01 ? 0.16 : posX - 0.005;
      if (cycleRef.current.position.x === 0.16) {
        cycleRef.current.visible = false;
      }
    }
    if (anotherCycleRef.current) {
      anotherCycleRef.current.visible = false;

      if (cycleRef.current.position.x <= 0.16) {
        const posX = anotherCycleRef.current.position.x;
        anotherCycleRef.current.visible = true;
        anotherCycleRef.current.position.x =
          Math.abs(1.2 - posX) < 0.01 ? 1.2 : posX + 0.007;

        if (anotherCycleRef.current.position.x == 1.2) {
          anotherCycleRef.current.visible = false;
          cycleRef.current.position.x = 1.2;
          anotherCycleRef.current.position.x = 0.16;
          cycleRef.current.visible = true;
        }
      }
    }

    //###################
    // ufo animation
    //###################

    if (ufoRef.current) {
      if (engage) {
        const posY = ufoRef.current.position.y;
        const posX = ufoRef.current.position.x;
        ufoRef.current.position.y =
          Math.abs(2 - posY) < 0.01 ? 2 : posY > 2 ? posY - 0.01 : posY + 0.01;
        ufoRef.current.position.x =
          Math.abs(-1 - posX) < 0.1 ? -1 : posX - 0.01;
        if (Math.abs(2 - posY) < 0.01 && Math.abs(-1 - posX) < 0.01) {
          if (!isIdle.current) {
            onStopped();
            isIdle.current = true;
          }
        }
      } else {
        ufoRef.current.position.x = THREE.MathUtils.lerp(
          ufoRef.current.position.x,
          -1,
          0.01
        );

        // ufo oscillates here
        ufoRef.current.position.y =
          2.2 + Math.sin(state.clock.elapsedTime * 1) * 0.3;
      }
    }
   //###################
    // profile pic animation
    //###################

    if (profileRef.current) {
      if (engage) {
        const posY = profileRef.current.position.y;
        const posX = profileRef.current.position.x;
        profileRef.current.position.y =
          Math.abs(2 - posY) < 0.01 ? 2.4 : posY > 2.4? posY - 0.01 : posY + 0.01;
          profileRef.current.position.x =
          Math.abs(-1 - posX) < 0.1 ? -1 : posX - 0.01;
        if (Math.abs(2 - posY) < 0.01 && Math.abs(-1 - posX) < 0.01) {
          if (!isIdle.current) {
            onStopped();
            isIdle.current = true;
          }
        }
      } else {
        profileRef.current.position.x = THREE.MathUtils.lerp(
          profileRef.current.position.x,
          -1,
          0.01
        );

        // ufo oscillates here
        profileRef.current.position.y =
          2.6 + Math.sin(state.clock.elapsedTime * 1) * 0.3;
      }
    }
    

    //###################
    // money animation
    //###################
    if (moneyRef.current && instaHeal && mode === "heal") {
      moneyRef.current.position.y = THREE.MathUtils.lerp(
        moneyRef.current.position.y,
        -1.8,
        0.02
      );

      if (Math.abs(moneyRef.current.position.y - -1.8) < 0.01) {
        moneyRef.current.material.opacity = THREE.MathUtils.lerp(
          moneyRef.current.material.opacity,
          0,
          0.03
        );
        if (moneyRef.current.material.opacity < 0.03) {
          isIdle.current = null;
          onEngaged();
          setInstaHeal(false);
        }
      }
    }

    //###################
    // money-2 animation
    //###################
    if (money2Ref.current && instaHeal && mode === "heal") {
      money2Ref.current.position.y = THREE.MathUtils.lerp(
        money2Ref.current.position.y,
        -1.9 - viewDiff * 0.09,
        0.03
      );
      money2Ref.current.position.x = THREE.MathUtils.lerp(
        -0.9,
        -1.8 - viewDiff * 0.09,
        0.02
      );

      if (Math.abs(moneyRef.current.position.y - -1.8) < 0.01) {
        money2Ref.current.material.opacity = THREE.MathUtils.lerp(
          money2Ref.current.material.opacity,
          0,
          0.03
        );
      }
    }

    //###################
    // money-3 animation
    //###################
    if (money3Ref.current && instaHeal && mode === "heal") {
      money3Ref.current.position.y = THREE.MathUtils.lerp(
        money3Ref.current.position.y,
        -1.9 - viewDiff * 0.09,
        0.04
      );
      money3Ref.current.position.x = THREE.MathUtils.lerp(
        -1.1,
        -1.8 - viewDiff * 0.09,
        0.03
      );

      if (Math.abs(moneyRef.current.position.y - -1.8) < 0.01) {
        money3Ref.current.material.opacity = THREE.MathUtils.lerp(
          money3Ref.current.material.opacity,
          0,
          0.03
        );
      }
    }

    //###################
    // cash animation
    //###################
    if (cashRef.current && instaHeal && mode === "heal") {
      cashRef.current.position.y = THREE.MathUtils.lerp(
        cashRef.current.position.y,
        -2.1 - viewDiff * 0.09,
        0.01
      );
      cashRef.current.position.x = THREE.MathUtils.lerp(
        -1.2,
        -1.8 - viewDiff * 0.09,
        0.01
      );

      if (Math.abs(moneyRef.current.position.y - -1.8) < 0.01) {
        cashRef.current.material.opacity = THREE.MathUtils.lerp(
          cashRef.current.material.opacity,
          0,
          0.03
        );
      }
    }

    //###################
    // cash-2 animation
    //###################

    if (cash2Ref.current && instaHeal && mode === "heal") {
      cash2Ref.current.position.y = THREE.MathUtils.lerp(
        cash2Ref.current.position.y,
        -1.8 - viewDiff * 0.09,
        0.03
      );
      cash2Ref.current.position.x = THREE.MathUtils.lerp(
        -1,
        -1.8 - viewDiff * 0.09,
        0.03
      );

      if (Math.abs(moneyRef.current.position.y - -1.8) < 0.01) {
        cash2Ref.current.material.opacity = THREE.MathUtils.lerp(
          cash2Ref.current.material.opacity,
          0,
          0.03
        );
      }
    }

    //###################
    // avatar animation
    //###################

    if (avatarRef.current && adminEngage) {
      avatarRef.current.position.y = THREE.MathUtils.lerp(
        avatarRef.current.position.y,
        -1.6 - viewDiff * 0.2,
        0.01
      );

      if (
        Math.abs(avatarRef.current.position.y - (-1.6 - viewDiff * 0.2)) < 0.01
      ) {
        if (!landed.current) {
          onLanded();
          landed.current = true;
        }
        avatarRef.current.material.opacity = THREE.MathUtils.lerp(
          avatarRef.current.material.opacity,
          0,
          0.03
        );

        if (Math.abs(avatarRef.current.material.opacity) < 0.03) {
          // if (!faded.current) {
          setAdminEngage(false);
          isIdle.current = landed.current = isLightOn.current = null;
          onEngaged();
          faded.current = true;
          // }
        }
      }
    }
  });

  return (
    <>
      <LightRay ref={lightRef} position={[-0.1, 2.3, 0.5]} />
      {!showMap && (
      <mesh position={communityDetail.doc ? [4, -6, -9] : [0.9, 0, 0]} >

        <mesh scale={viewScale5x} position={ufoConfig.position} ref={ufoRef}>
          <TexturedPlane
            opacity={1}
            // texture={imageDetail.common[13].img}
            texture={ufoConfig.type}
            size={ufoConfig.size}
          />
        </mesh>
        {(authDetail.authToken && (authDetail.isCitizen || authDetail.isAdmin) ) &&
        <mesh scale={viewScale5x} position={profileConfig.position} ref={profileRef}>
          <TexturedPlane
            opacity={1}
            circle={true}
            texture={authDetail.user_details.imageUrl?authDetail.user_details.imageUrl:imageDetail.default[0].img}
            // texture={profileConfig.type}
            size={profileConfig.size}
          />
        </mesh>}

        {cloudConfig.map((data: any) => {
          return (
            <mesh
              scale={viewScale}
              position={
                communityDetail.doc
                  ? data.cloud_position_sm
                  : data.cloud_position_lg
              }
              ref={data.ref == "cloudRef" ? cloudRef : anotherCloudRef}
            >
              <TexturedPlane
                opacity={1}
                texture={data.type}
                size={data.cloud_size}
              />
            </mesh>
          );
        })}

        {instaHeal && (
          <>
            {cashConfig.map((data: any) => {
              return (
                <mesh
                  scale={viewScale}
                  position={data.cash_position}
                  ref={
                    data.ref == "moneyRef"
                      ? moneyRef
                      : data.ref == "money2Ref"
                      ? money2Ref
                      : data.ref == "money3Ref"
                      ? money3Ref
                      : data.ref == "cashRef"
                      ? cashRef
                      : cash2Ref
                  }
                >
                  <Money
                    size={data.cash_size}
                    type={data.type}
                    opacity={instaHeal ? 1 : 0}
                  />
                </mesh>
              );
            })}
          </>
        )}

        {adminEngage && (
          <mesh ref={avatarRef} scale={viewScale5x} position={[-1, 2, 0.6]}>
            <TexturedPlane
              texture={engAvatr}
              size={[0.4, 0.5]}
              opacity={adminEngage ? 1 : 0}
            />
          </mesh>
        )}

        {planetStructure.cycle ? (
          <>
            <mesh
              scale={viewScale5x}
              position={planetStructure.cycle_position.right}
              ref={cycleRef}
            >
              <TexturedPlane
                texture={planetStructure.cycle.right}
                size={planetStructure.cycle_size}
                opacity={1}
              />
            </mesh>

            <mesh
              scale={viewScale5x}
              position={planetStructure.cycle_position.left}
              ref={anotherCycleRef}
            >
              <TexturedPlane
                texture={planetStructure.cycle.left}
                size={planetStructure.cycle_size}
                opacity={1}
              />
            </mesh>
          </>
        ) : (
          <></>
        )}

        {planetStructure.boy ? (
          <mesh
            scale={viewScale5x}
            position={[
              planetStructure.boy_x + viewDiff * 1.9,
              planetStructure.boy_y,
              planetStructure.boy_z,
            ]}
          >
            <TexturedPlane
              texture={planetStructure.boy}
              size={planetStructure.boy_size}
              opacity={1}
            />
          </mesh>
        ) : (
          <></>
        )}

        <mesh
          scale={viewScale5x}
          position={[
            planetStructure.bench_x + viewDiff * 1.9,
            planetStructure.bench_y,
            planetStructure.bench_z,
          ]}
        >
          <TexturedPlane
            texture={planetStructure.bench}
            size={planetStructure.bench_size}
            opacity={1}
          />
        </mesh>
        {planetStructure.family ? (
          <mesh
            scale={viewScale5x}
            position={[
              planetStructure.family_x - viewDiff * 1,
              planetStructure.family_y + viewDiff * 0.2,
              planetStructure.family_z,
            ]}
          >
            <TexturedPlane
              texture={planetStructure.family}
              size={planetStructure.family_size}
              opacity={1}
            />
          </mesh>
        ) : (
          <></>
        )}

        <mesh
        onClick={clickLocation}
          scale={viewScale}
          position={[
            planetStructure.surface_x - viewDiff * 0.1,
            planetStructure.surface_y - viewDiff * 1,
            planetStructure.surface_z,
          ]}
          ref={surfaceRef}
        >
          <TexturedPlane
            texture={planetStructure.surface}
            opacity={1}
            size={planetStructure.surface_size}
          />
        </mesh>

        <mesh
          scale={viewScale}
          position={[
            planetStructure.land_x,
            planetStructure.land_y + viewDiff * 1.5,
            planetStructure.land_z,
          ]}
          ref={surfaceRef}
        >
          <TexturedPlane
            texture={planetStructure.land}
            size={planetStructure.land_size}
            opacity={1}
          />
        </mesh>
      </mesh>)}

      
    </>
  );
};

export default PlanetManage;
